"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInsightProcessModalCtrl = void 0;
var tslib_1 = require("tslib");
var services_1 = require("../../services");
var CollectionInsightProcessModalCtrl = /** @class */ (function () {
    function CollectionInsightProcessModalCtrl(collections) {
        this.collections = collections;
    }
    //we take the departmentId as a parameter to make inter department duplication easier to implement even if it is not currently needed
    CollectionInsightProcessModalCtrl.prototype.insightProcessCollections = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var departmentId, collectionIds;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        departmentId = (_a = services_1.Services.Department.current) === null || _a === void 0 ? void 0 : _a.objectId;
                        collectionIds = this.collections.map(function (c) { return c.collectionId; });
                        if (!departmentId) {
                            throw Error('No departmentId found');
                        }
                        return [4 /*yield*/, services_1.Services.Department.rest.Collection.insightProcess({
                                departmentId: departmentId,
                                where: { collectionId: { $in: collectionIds } },
                                dryRun: false
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return CollectionInsightProcessModalCtrl;
}());
exports.CollectionInsightProcessModalCtrl = CollectionInsightProcessModalCtrl;
//# sourceMappingURL=collection.insight.process.modal.ctrl.js.map